module.exports = __webpack_public_path__ + "img/symbol_19.5c7b334e.png";